<div>
  <div class="align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center mb-1"
       style="color: #6f6f6f;">
    <div class="tc w-20 mr-3">
      &nbsp;
    </div>
    <div class="w-100">
      &nbsp;&nbsp;<b>{{'lang.schedulesAssignment.deviceFilter' | translate}}</b>
    </div>
    <div class="w-100">
      &nbsp;&nbsp;<b>{{'lang.schedulesAssignment.schedule' | translate}}</b>
    </div>
  </div>
  <div *ngFor="let app of approvals"
       class="card align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center mb-1"
       style="color: #6f6f6f;">
    <div class="tc w-20 mr-3">
      <div class="card" style="height: 64px; width: 64px; margin-bottom: 0;">
        <sb-custom-icons style="font-size: 32px;" class="custom-icons"
                         name="intersect-arrow-right"></sb-custom-icons>
      </div>
    </div>
    <div class="w-100">
      <div ngbDropdown class="d-inline-block">
        <button class="btn btn-outline-primary" ngbDropdownToggle>{{app.deviceFilter}}</button>
        <div ngbDropdownMenu>
          <button ngbDropdownItem *ngFor="let filter of options.deviceFilter"
                  [ngClass]="filter === app.deviceFilter ? 'active' : ''"
                  (click)="app.deviceFilter=filter">{{filter}}</button>
        </div>
      </div>
    </div>
    <div class="w-100">
      <div ngbDropdown class="d-inline-block">
        <button class="btn btn-outline-primary" ngbDropdownToggle>{{app.schedule}}</button>
        <div ngbDropdownMenu>
          <button ngbDropdownItem *ngFor="let filter of options.schedule"
                  [ngClass]="filter === app.schedule ? 'active' : ''"
                  (click)="app.schedule=filter">{{filter}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
